export default {
    COMPANY: 'company',
    INDIVIDUAL: 'individual',
    THIRD_PARTY: 'thirdParty'
};